import { HiExclamationTriangle, HiArrowTopRightOnSquare } from "react-icons/hi2";
import { ResultStatusIcon } from "./ResultPrimitives";
import CustomButton from "../../ui/CustomButton/CustomButton";

export function ResultErrorFallback({
  title,
  message,
  primaryLabel,
  onPrimaryClick,
  onRetry,
  retryLabel = "Retry",
}) {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col items-center text-center gap-3">
        <ResultStatusIcon
          icon={HiExclamationTriangle}
          bgClassName="bg-amber-50"
          iconClassName="text-amber-500"
        />
        <div className="space-y-1">
          <p className="text-sm sm:text-base font-semibold text-amber-600">
            {title}
          </p>
          <p className="text-xs sm:text-sm text-gray-500 max-w-xs">
            {message}
          </p>
        </div>
      </div>

      <div className="w-full max-w-sm sm:max-w-md mx-auto grid grid-cols-1 xs:grid-cols-2 gap-2">
        <CustomButton
          fullWidth
          color="primary"
          radius="md"
          leftSection={<HiArrowTopRightOnSquare style={{ fontSize: 14 }} />}
          onClick={onPrimaryClick}
        >
          {primaryLabel}
        </CustomButton>
        <CustomButton
          fullWidth
          variant="outline"
          color="gray"
          radius="md"
          onClick={onRetry}
        >
          {retryLabel}
        </CustomButton>
      </div>
    </div>
  );
}
